import Raven from 'raven-js';
import { useCallback, useContext, useRef } from 'react';
import { gate } from 'hub-http/gates';
import { useIsUngated } from 'ai-components-ui-library/hooks/useIsUngated';
import { PreviewEventType } from '../types/preview';
import { CopilotPreviewContext } from '../components/CopilotPreview/context/CopilotPreviewContextProvider';
import { isSimplifiedPreviewResult } from '../components/CopilotPreview/internalV2/utils/previewMigrationUtils';
export const useGetSubscriptionHandler = () => {
  const localPreviewData = useRef({
    text: ''
  });
  const {
    updatePreviewData
  } = useContext(CopilotPreviewContext);
  const isUngatedForSimplifiedPreviews = useIsUngated(gate('CopilotPreviewsV2:Simplified'));
  return useCallback(message => {
    try {
      const data = typeof message.data === 'string' && message.name !== PreviewEventType.PREVIEW_START // don't parse preview start message
      ? JSON.parse(message.data) : message.data;
      switch (message.name) {
        // Start of preview stream
        case PreviewEventType.PREVIEW_START:
          {
            // represents user message, don't do anything with it
            break;
          }
        case PreviewEventType.PREVIEW_MESSAGE_DELTA:
          {
            // Update text incrementally while preserving state
            localPreviewData.current.text += data.text;
            updatePreviewData({
              text: localPreviewData.current.text
            });
            break;
          }
        case PreviewEventType.PREVIEW_END:
          {
            // Mark as complete and include preview messages

            // Special handling for simplified previews
            if (isUngatedForSimplifiedPreviews && isSimplifiedPreviewResult(data)) {
              updatePreviewData({
                isStreamingComplete: true,
                previewMessages: [data]
              });
            } else {
              updatePreviewData({
                isStreamingComplete: true,
                previewMessages: data.previewMessages
              });
            }
            localPreviewData.current.text = ''; // reset text
            break;
          }
        case PreviewEventType.PREVIEW_EXCEPTION:
          {
            var _data$message;
            // Update with error info
            updatePreviewData({
              isStreamingComplete: true,
              errorCode: ((_data$message = data.message) === null || _data$message === void 0 ? void 0 : _data$message.errorCode) || 'FALLBACK_ERROR_CODE'
            });
            break;
          }
        default:
          throw new Error(`Unknown message name: ${message.name}`);
      }
    } catch (error) {
      Raven.captureException(error, {
        extra: {
          eventName: message.name
        }
      });
    }
  }, [isUngatedForSimplifiedPreviews, updatePreviewData]);
};